// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d7b9c4d0","977":"4fcd0f05"}[chunkId] + ".chunk.js";
};